<script setup>
import {ref} from "vue";

const data = ref([
  {
    name: 'Request',
    value: 'request'
  },
  {
    name: 'Enquiries',
    value: 'enquiries'
  },
  {
    name: 'Feedback',
    value: 'feedback',
  },
  {
    name: 'Youtube',
    value: 'youtube'
  }
])
import EmptyCardComponent from "@/components/cards/EmptyCardComponent.vue";
import TextInputComponent from "@/components/form/TextInputComponent.vue";
import TextAreaComponent from "@/components/form/TextAreaComponent.vue";
import SelectInputComponent from "@/components/form/SelectInputComponent.vue";
import BasicButtonComponent from "@/components/form/BasicButtonComponent.vue";
</script>

<template>
  <section
    id="contact-form"
    class="max-w-fit md:max-w-full mx-auto"
  >
    <EmptyCardComponent
      class="rounded-xl p-5"
      style="
          backdrop-filter: blur(100%);
          background-color: rgba(255, 255, 255, 0.9);"
    >
      <template #body>
        <p class="text-sm mb-8 text-gray-500 drop-shadow-md">
          Need help on how to use the site? watch the how to video
          <a
            href=""
            class="text-green-500"
          >here</a>
        </p>

        <h2 class="text-3xl font-semibold mt-5 mb-3 text-gray-600">
          Connect with us
        </h2>
        <p class="text-gray-500 text-sm">
          Fill & submit the form to contact us for
          <i class="text-gray-800">Request, Enquiries or Recommendations</i>
        </p>

        <form
          id="contact-form"
          class="mt-5 max-w-full"
        >
          <div class="flex flex-col md:flex-row items-center justify-center md:space-x-4 w-full">
            <text-input-component
              class="py-3 mb-4 placeholder:text-base placeholder-gray-400"
              placeholder="First Name"
            />
            <text-input-component
              class="py-3 mb-4 placeholder:text-base placeholder-gray-400"
              placeholder="Last Name"
            />
          </div>
          <div class="flex flex-col md:flex-row items-center justify-center md:space-x-4">
            <text-input-component
              class="py-3 mb-4 placeholder:text-base placeholder-gray-400"
              placeholder="Email"
            />
            <select-input-component
              class="py-3 mb-4 placeholder:text-base placeholder-gray-400 appearance-none"
              :data="data"
            />
          </div>
          <text-area-component
            class="py-3 mb-4 placeholder:text-base placeholder-gray-400"
          />
          <basic-button-component
            type="submit"
            class="mt-4 w-full text-lg text-white font-semibold py-3 block ml-auto bg-green-600"
          >
            Submit
          </basic-button-component>
        </form>
      </template>
    </EmptyCardComponent>
  </section>
</template>

<style scoped>

</style>